import { atom } from "recoil";

import {
  IClipCompetitionStatus,
  ICreateCompetitionInput,
  IEligibleClip,
  TCompetitionStatus,
  TCompetitionSort,
} from "MVVM/Views/Competitions/@types";
import { persistAtom } from "./persist";

export const CompetitionEligibilityState = atom<{
  byShareId: Record<string, IClipCompetitionStatus[]>;
  loaded: boolean;
}>({
  key: "CompetitionEligibility_V0.1",
  default: { byShareId: {}, loaded: false },
});

export const CompetitionHubFiltersState = atom<{
  status: TCompetitionStatus;
  sort: TCompetitionSort;
}>({
  key: "CompetitionHubFilters_V0.2",
  default: {
    status: "ACTIVE",
    sort: "NEWEST",
  },
});

export const CreateCompetitionFormState = atom<
  Partial<ICreateCompetitionInput>
>({
  key: "CreateCompetitionForm_V0.5",
  default: {
    title: "",
    description: "",
    visibility: "public",
    sponsored: false,
    internalOnly: false,
    bannerGraphic: "",
    entryRequirement: {
      subscriptionTier: null,
      userCap: null,
      minClipCount: null,
      maxClipCount: null,
      minAccountAgeDays: null,
      excludePriorWinners: false,
      teamId: null,
    },
    submissionRule: {
      selfSubmitted: true,
      mustBeOwnClip: true,
      clipCap: null,
      dailySubmissionLimit: 3,
    },
    clipRequirement: {
      allowRemixed: false,
      mustBeCreatedAfterStart: true,
      mustMatchAfterStart: true,
      requiredGames: [7302],
      requiredTags: [],
    },
    rankingConfig: {
      allstarScoreType: "average",
    },
    prizes: [],
  },
  effects_UNSTABLE: [persistAtom],
});

export const CreateCompetitionStepState = atom<number>({
  key: "CreateCompetitionStep_V0.1",
  default: 0,
});

export const SelectedClipsForSubmissionState = atom<IEligibleClip[]>({
  key: "SelectedClipsForSubmission_V0.2",
  default: [],
});
